export default {
  jwtSecret: '@QEGTUI',
  domain: process.env.NODE_ENV === 'development' ? 'http://localhost:3001/' : 'https://api.appsmmo.com/',
  imageUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:3001/images' : 'https://api.appsmmo.com/images',
  thumbUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:3001/images/thumb' : 'https://api.appsmmo.com/images/thumb'
};
